/**
 * "Mark reviewed" flips an auto area to `curator`. It is offered only for Tina's own areas, and
 * in a city that has parts only once the area sits in one: Tina's nightly re-parents every
 * unparented area, so a curator stamp on it would hide work still to be done.
 */
export const canMarkReviewed = (
  area: { origin: string; kind: string; parentId?: string | null },
  cityHasParts: boolean,
): boolean => {
  if (area.origin !== "auto") return false;
  if (!cityHasParts) return true;
  return area.kind === "part" || Boolean(area.parentId);
};
